import { useQuery } from '@tanstack/react-query';
import { ConstructionQsStatsService } from '../services/constructionQsStats.service';
import type { QsDashboardStats } from '../types/construction-qs.types';

export function useQsDashboard(companyId: string, projectId?: string) {
  const query = useQuery({
    queryKey: ['construction-qs-dashboard', companyId, projectId],
    queryFn: () => ConstructionQsStatsService.getDashboardStats(companyId, projectId),
    enabled: !!companyId,
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
